/**
 * Created by ap on 15/03/18.
 */

import { Component, ElementRef, Input, Optional, ViewChild, ViewEncapsulation, effect } from '@angular/core';
import { ChangeDetectionStrategy, Renderer2, ChangeDetectorRef } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Observable } from 'rxjs';
import {
  ActionCallbackInterface,
  PaymentProcessingModalConfigInterface,
  ProcessActionInterface,
} from '../../interfaces';
import { PaymentProcessingUserActionInterface } from './payment-processing-user-action.interface';
import { PaymentProcessingActions } from './payment-processing-actions.enum';
import { SetTimeoutUtil } from '@core/services/utils/settimeout.utils';
import { PaymentProcessingUserActions } from './payment-processing-user-actions.enum';
import { NavParams } from '@ionic/angular';
import { PaymentProcessingService } from '@shared/components/payment-processing/payment-processing.service';

@Component({
  selector: 'payment-processing',
  styleUrls: ['payment-processing.component.scss'],
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'payment-processing.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentProcessing {
  @Input() config: PaymentProcessingModalConfigInterface;

  public activeScreen: PaymentProcessingActions;
  public terminalMsg: string;
  public fadeAnim: boolean = false;
  public retryButtonOff: boolean;
  public cancelButtonOff: boolean;
  public checkButtonOff: boolean;

  private actionCallback: ActionCallbackInterface;
  private adyenConfig: PaymentProcessingModalConfigInterface;

  onUserAction: ActionCallbackInterface;
  actionsDispatcher: Observable<ProcessActionInterface> = this.paymentProcessingService.process;
  providerDataStream: Observable<string> = this.paymentProcessingService.additionalData;

  @ViewChild('sHeight', { static: true }) sHeight: ElementRef;

  constructor(
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private setTimeoutUtil: SetTimeoutUtil,
    private paymentProcessingService: PaymentProcessingService,
    @Optional() private navParams: NavParams
  ) {
    this.adyenConfig = this.navParams?.get('config');
    this.initActionsDispatcherEffect();
    this.initProviderDataEffect();
  }

  private initActionsDispatcherEffect(): void {
    let timeout = 0;
    const actionsSignal = toSignal(this.actionsDispatcher, { initialValue: undefined });
    effect(() => {
      const event = actionsSignal();
      if (!event?.action) return;
      if (event.action === PaymentProcessingActions.close) {
        this.onUserActionEvent({ type: PaymentProcessingUserActions.close });
        return;
      }
      this.terminalMsg = '';
      this.fadeAnim = false;
      this.setTimeoutUtil.waitTimeAndDo(timeout).then(() => {
        timeout = 200;
        this.fadeAnim = true;
        this.activeScreen = event.action;
        if (event.configuration?.message) {
          this.terminalMsg = event.configuration.message;
        }
        this.cancelButtonOff = event.configuration.cancelButtonOff;
        this.retryButtonOff = event.configuration.retryButtonOff;
        this.checkButtonOff = event.configuration.checkButtonOff;
        this.actionCallback = event.callback;
        this.maxHeight();
      });
      this.maxHeight();
    });
  }

  private initProviderDataEffect(): void {
    const providerDataSignal = toSignal(this.providerDataStream, { initialValue: undefined });
    effect(() => {
      const data = providerDataSignal();
      if (data === undefined) return;
      this.terminalMsg = data;
      this.maxHeight();
    });
  }

  private maxHeight() {
    this.setTimeoutUtil.addVisualEffect(50).then(() => {
      const maxHeight = this.sHeight.nativeElement.offsetHeight + 20
      this.renderer.setStyle(this.sHeight.nativeElement.parentElement, 'max-height', maxHeight + 'px');
    });
    this.cdr.markForCheck();
  }

  onUserActionEvent(event: PaymentProcessingUserActionInterface) {
    const config: PaymentProcessingModalConfigInterface = this.adyenConfig || this.config;
    this.paymentProcessingService.handleUserAction(event, config);
    if (this.actionCallback) {
      this.actionCallback(event);
    }
  }
}
